import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { JetourHome } from './types';

export function useJetourHomeData(): Page<JetourHome>['templateFields'] {
  return useCurrentPage<Page<JetourHome>>().templateFields;
}
